import { ConversationCardComponent } from './components/conversation_card/conversation_card_controller';
import { ConversationFilterComponent } from './components/conversation_filter/conversation_filter_controller';
import { ConversationListContentComponent } from './components/conversation_list_content/conversation_list_content_controller';
import { ConversationThreadCardComponent } from './components/conversation_thread_card/conversation_thread_card_controller';
import { ConversationThreadsContentComponent } from './components/conversation_threads_content/conversation_threads_content_controller';
import { ConversationsCapabilityConfiguration } from './configuration';
import { ConversationThreadsQuery } from './queries/conversation_threads_query';
import { ConversationsPriorityFeedQuery } from './queries/conversations_priority_feed_query';
import { ConversationsQuery } from './queries/conversations_query';
import { ConversationsRoutes } from './routes';
import { ConversationThreadServant } from './servants/conversation_thread_servant';
import { ConversationListController } from './views/conversation_list/conversation_list_controller';

angular
  .module('capability-ng-conversations', [])
  .component('conversationCard', new ConversationCardComponent())
  .component('conversationListContent', new ConversationListContentComponent())
  .component('conversationThreadCard', new ConversationThreadCardComponent())
  .component('conversationThreadsContent', new ConversationThreadsContentComponent())
  .component('conversationFilter', new ConversationFilterComponent())
  .controller('ConversationListController', ConversationListController)
  .service('ngConversationThreadServant', ConversationThreadServant)
  .service('ngConversationThreadsQuery', ConversationThreadsQuery)
  .service('ngConversationsQuery', ConversationsQuery)
  .service('ngConversationsCapabilityConfiguration', ConversationsCapabilityConfiguration)
  .service('ngConversationsPriorityFeedQuery', ConversationsPriorityFeedQuery)
  .config(ConversationsRoutes);

import './core';

export * from './queries/conversations_priority_feed_query';
export * from './configuration';

export default 'capability-ng-conversations';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/main.ts